(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/react/amount-with-currency.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/react/amount-with-currency.js');
'use strict';

const AmountWithCurrency = _ref => {
  let {
    amount
  } = _ref;
  const positiveAmount = amount >= 0 ? amount : 0;
  return React.createElement(React.Fragment, null, svs.utils.format.Currency(positiveAmount), ' ', React.createElement("abbr", {
    "aria-label": "kronor",
    title: "kronor"
  }, "kr"));
};
svs.accountservicesReact.gameLimitDepositsForm.AmountWithCurrency = AmountWithCurrency;

 })(window);